import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const SearchCode: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'm9 9-2 2 2 2' }],
    ['path', { d: 'm13 13 2-2-2-2' }],
    ['circle', { cx: '11', cy: '11', r: '8' }],
    ['path', { d: 'm21 21-4.3-4.3' }],
  ],
];

export default SearchCode;
